import { INICIO_CONTENT } from "./inicio.js";
import { MOSTRADOR_CONTENT } from "./mostrador.js";
import { SOCIOS_CONTENT } from "./socios.js";
import { CLASES_CONTENT } from "./clases.js";
import { KIOSKO_CONTENT } from "./kiosko.js";
import { PERSONAL_CONTENT } from "./personal.js";
import { CAJA_CONTENT } from "./caja.js";
import { FACTURACION_CONTENT } from "./facturacion.js";
import { GASTOS_CONTENT } from "./gastos.js";
import { COMUNICACION_CONTENT } from "./comunicacion.js";
import { REPORTES_CONTENT } from "./reportes.js";
import { CONFIGURACION_CONTENT } from "./configuracion.js";
import { PROFES_CONTENT } from "./profes.js";
export const CONTENT_BY_MODULE = {
    inicio: INICIO_CONTENT,
    mostrador: MOSTRADOR_CONTENT,
    socios: SOCIOS_CONTENT,
    clases: CLASES_CONTENT,
    kiosko: KIOSKO_CONTENT,
    personal: PERSONAL_CONTENT,
    caja: CAJA_CONTENT,
    facturacion: FACTURACION_CONTENT,
    gastos: GASTOS_CONTENT,
    comunicacion: COMUNICACION_CONTENT,
    reportes: REPORTES_CONTENT,
    configuracion: CONFIGURACION_CONTENT,
    profes: PROFES_CONTENT,
};
//# sourceMappingURL=index.js.map